import Header from "components/Layouts/Header"
import PATHS from "router/paths"
import { useNavigate } from "react-router-dom"
import { CreateMyFoodFormSection } from ".."
import { useMealTypeQueryParams } from "features/meal/hooks"

interface CreateFoodHeaderProps {
  section: CreateMyFoodFormSection
  isFormEmpty: boolean
  setSection: (section: CreateMyFoodFormSection) => void
  setIsPopConfirmDiscardOpen: (isOpen: boolean) => void
  disabled: boolean
}

const CreateFoodHeader = ({
  section,
  isFormEmpty,
  setSection,
  setIsPopConfirmDiscardOpen,
  disabled,
}: CreateFoodHeaderProps) => {
  const navigate = useNavigate()
  const mealTypeQueryParams = useMealTypeQueryParams()

  const backToRecipes = () => {
    navigate(`${PATHS.app.myFoods.recipes}${mealTypeQueryParams}`)
  }

  const onBack = () => {
    if (section !== CreateMyFoodFormSection.Form) {
      setSection(CreateMyFoodFormSection.Form)
    } else {
      if (isFormEmpty) {
        backToRecipes()
      } else {
        setIsPopConfirmDiscardOpen(true)
      }
    }
  }

  const shouldShowHeader = section !== CreateMyFoodFormSection.IngredientDetails

  if (!shouldShowHeader) return null

  return (
    <Header
      isAppPaddingStyle
      title={
        section === CreateMyFoodFormSection.Form
          ? "Create New Meal"
          : "Add Ingredients"
      }
      onBack={onBack}
      disabled={disabled}
    />
  )
}

export default CreateFoodHeader
